import {DEFAULT_PRICING_STRATEGY} from '@dms/api/shared';

export const userSettingsMockResponse = {
  sourcingCurrency: {
    key: 'sourcing_currency',
    value: 'CZK',
  },
  sourcingBuyerCountry: {
    key: 'sourcing_buyer_country',
    value: 'CZE',
  },
  sourcingPricingStrategy: {
    key: 'sourcing_pricing_strategy',
    value: DEFAULT_PRICING_STRATEGY,
  },
  activeBranch: {
    key: 'active_branch',
    value: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  selectedLanguage: {
    key: 'selected_language',
    value: 'en',
  },
  inactivityPeriod: {
    key: 'inactivity_period',
    value: 'INACTIVITY_PERIOD_NEVER',
  },
  insurerNumber: {
    key: 'insurer_number',
    value: null,
  },
  customId: {
    key: 'custom_id',
    value: null,
  },
};
